import React from 'react'
import { Link } from 'react-router-dom'
import {
    Button,
    Badge,
    Divider,
    List,
    ListItem,
    IconButton,
    Typography,
    Popover,
    Box,
    CircularProgress,
} from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { faEnvelope } from '@fortawesome/pro-duotone-svg-icons/faEnvelope'
import { faBell } from '@fortawesome/pro-duotone-svg-icons/faBell'
import { faInbox } from '@fortawesome/pro-duotone-svg-icons/faInbox'

import { faEnvelopeOpen } from '@fortawesome/free-regular-svg-icons'
import LoadingDefault from '@/Components/Elements/Loading/LoadingDefault'
import DOMPurify from 'dompurify'
import AppDialog from '@/Components/AppDialog'
import { StyledButton } from '@/Components/Elements/StyledComponents/Buttons'

class MessagesPopOver extends React.Component {
    _isMounted = false

    constructor(props) {
        super(props)
        this.state = {
            count: 0,

            currentPopUp: 0,
            newMessages: [],
            loaded: false,
            loading: false,
            msgInterval: false,
            popInterval: false,
            popupItems: [],
            showPopOver: false,
        }
        this.target = React.createRef()
        this.fetchCount = this.fetchCount.bind(this)
        this.fetchNewMessages = this.fetchNewMessages.bind(this)
        this.fetchPopups = this.fetchPopups.bind(this)
        this.onClickMessage = this.onClickMessage.bind(this)
        this.popupMessagesPagination = this.popupMessagesPagination.bind(this)
    }

    fetchPopups(isFirst) {
        if ((!isFirst && this.state.loading) || this._isMounted !== true) {
            return
        }

        let url =
            this.props.kedo.api().getMessageEndpoint() +
            '?type=popup&new=1&filter=incoming'
        this.setState({ loading: true })

        this.props.kedo
            .api()
            .get(url, {}, false)
            .then((response) =>
                this.setState({
                    loading: false,
                    popupItems: response.data.results,
                })
            )
    }

    fetchNewMessages() {
        if (this.state.loading || this._isMounted !== true) {
            return
        }

        let url =
            this.props.kedo.api().getMessageEndpoint() +
            '?limit=5&new=1&filter=incoming'
        this.setState({ loading: true })

        this.props.kedo
            .api()
            .get(url)
            .then((response) =>
                this.setState({
                    loading: false,
                    loaded: true,
                    newMessages: response.data.results,
                })
            )
    }

    fetchCount() {
        if (
            this._isMounted !== true ||
            true !== this.props.kedo.user().isLoggedIn()
        ) {
            return
        }

        let url = this.props.kedo.api().getMessageEndpoint() + '/unread/count'
        this.setState({ loading: true })
        this.props.kedo
            .api()
            .get(url, {}, false)
            .then((response) => {
                this.setState({
                    count: response.data.total,
                    loading: false,
                })
            })
            .catch((error) =>
                this.setState({
                    count: 0,
                    loading: false,
                })
            )
    }

    shortenTitle(title) {
        let dotsNeeded = title.length >= 30
        let trimmedString = title.substr(0, 30)

        trimmedString = trimmedString.substr(
            0,
            Math.min(trimmedString.length, trimmedString.lastIndexOf(' '))
        )
        trimmedString = dotsNeeded ? trimmedString + '...' : title

        return trimmedString
    }

    shortenText(text) {
        let dotsNeeded = text.length >= 100
        let trimmedString = text.substr(0, 100)

        trimmedString = trimmedString.substr(
            0,
            Math.min(trimmedString.length, trimmedString.lastIndexOf(' '))
        )
        trimmedString = dotsNeeded ? trimmedString + '...' : text

        return trimmedString
    }

    onClickMessage() {
        this.setState({ showPopOver: false, count: this.state.count - 1 })
        this.toTop()
    }

    getItems() {
        const uniqueMessages = this.state.newMessages.filter(
            (msg, index, self) =>
                index === self.findIndex((m) => m.id === msg.id)
        )

        return (
            <List className="notification">
                {uniqueMessages.slice(0, 5).map((item) => (
                    <React.Fragment key={item.id}>
                        <ListItem
                            key={item.id}
                            component={Link}
                            to={`/messages/${item.id}`}
                            onClick={this.onClickMessage}
                            className={item.read_date ? 'newNotification' : ''}
                            sx={{
                                flexDirection: 'column',
                                alignItems: 'flex-start',
                                paddingY: 1,
                            }}
                        >
                            <Badge
                                badgeContent={null}
                                color="primary"
                                sx={{ mb: 0.5, ml: 'auto' }}
                            >
                                <Typography variant="caption">
                                    {this.props.kedo.t('Sender')}:{' '}
                                    {item.sender_name}
                                </Typography>
                            </Badge>

                            <Typography
                                variant="subtitle2"
                                className="messageTitle readMore"
                            >
                                {this.shortenTitle(item.title)}
                            </Typography>

                            <Typography
                                variant="body2"
                                className="messageText"
                                dangerouslySetInnerHTML={{
                                    __html: DOMPurify.sanitize(
                                        this.shortenText(item.message_text)
                                    ),
                                }}
                            />
                        </ListItem>
                        <Divider />
                    </React.Fragment>
                ))}

                {uniqueMessages.length <= 0 && (
                    <ListItem>
                        {this.props.kedo.t('No unread messages')}
                    </ListItem>
                )}

                {this.state.count > 5 && (
                    <ListItem>
                        <Typography variant="caption" color="textSecondary">
                            + {this.state.count - 5}{' '}
                            {this.props.kedo.t('remaining unread messages')}
                        </Typography>
                    </ListItem>
                )}
            </List>
        )
    }

    setViewedPopupItem(item) {
        this.setState({ loadingPopup: true })
        this.props.kedo
            .api()
            .get(this.props.kedo.api().getMessageEndpoint() + '/' + item.id)
            .then((response) => {
                let popupItems = this.state.popupItems.filter(
                    (popItem) => item.id !== popItem.id
                )
                this.setState({
                    popupItems: popupItems,
                    loadingPopup: false,
                })
            })
    }

    renderPopupItems() {
        const firstItem = this.state.popupItems[0]

        return (
            <AppDialog
                open={true}
                topAlign={true}
                onClose={() => this.setState({ popupItems: [] })}
                actions={
                    <Box sx={{ display: 'flex', gap: 1, mb: 1, mr: 'auto' }}>
                        <StyledButton
                            onClick={() => this.setViewedPopupItem(firstItem)}
                            disabled={this.state.loadingPopup}
                        >
                            {this.state.loadingPopup ? (
                                <LoadingDefault as="span" size="small" />
                            ) : (
                                <FontAwesomeIcon icon={faEnvelopeOpen} />
                            )}
                            &nbsp; {this.props.kedo.t('Mark as read')}
                        </StyledButton>

                        <Link to="/messages">
                            <StyledButton
                                color="secondary"
                                onClick={() =>
                                    this.setState({ popupItems: [] })
                                }
                            >
                                <FontAwesomeIcon icon={faInbox} />
                                &nbsp; {this.props.kedo.t('Go to')}{' '}
                                {this.props.kedo.t('Inbox').toLowerCase()}
                            </StyledButton>
                        </Link>
                    </Box>
                }
            >
                <Box
                    sx={{
                        maxWidth: 600,
                        bgcolor: 'background.paper',
                        mt: 1,
                        borderRadius: 1,
                        outline: 'none',
                    }}
                >
                    <Typography
                        variant="h6"
                        sx={{
                            mb: 2,
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1,
                        }}
                    >
                        <FontAwesomeIcon icon={faEnvelope} />
                        {this.props.kedo.t('You have a message from')}{' '}
                        {firstItem.sender_name}
                    </Typography>
                    <Divider />
                    <Box
                        sx={{
                            my: 2,
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                        }}
                    >
                        <Link
                            to={`/user/${firstItem.sender_id}`}
                            onClick={() => this.setState({ popupItems: [] })}
                        >
                            <Box
                                component="span"
                                className="badge badge-primary"
                                sx={{
                                    m: 0,
                                    py: 0.25,
                                    px: 0.5,
                                    lineHeight: 1.3,
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                }}
                            >
                                {this.props.kedo.t('Sender')}:{' '}
                                {firstItem.sender_name}
                            </Box>
                        </Link>

                        <Box
                            component="span"
                            className="badge badge-secondary"
                            sx={{
                                ml: 1,
                                display: 'inline-flex',
                                alignItems: 'center',
                            }}
                        >
                            {this.props.kedo
                                .utils()
                                .dateFormat(firstItem.created_at)}
                        </Box>
                    </Box>

                    <Typography variant="h5" sx={{ mb: 1 }}>
                        {firstItem.title}
                    </Typography>

                    <Typography
                        variant="body2"
                        dangerouslySetInnerHTML={{
                            __html: DOMPurify.sanitize(firstItem.message_text),
                        }}
                    />

                    {this.state.popupItems.length > 1 && (
                        <Box
                            sx={{
                                textAlign: 'center',
                                mt: 2,
                                color: 'text.secondary',
                            }}
                        >
                            {this.popupMessagesPagination()}
                            <Typography variant="caption">
                                {this.props.kedo.t('Message')} 1 /{' '}
                                {this.state.popupItems.length}
                            </Typography>
                        </Box>
                    )}
                </Box>
            </AppDialog>
        )
    }

    toTop() {
        window.scrollTo(0, 0)
    }

    popupMessagesPagination() {
        // TODO PAGINATION
        const pageNumbers = []

        for (let i = 1; i <= this.state.popupItems.length; i++) {
            pageNumbers.push(i)
        }

        if (pageNumbers.length === 1) pageNumbers.pop()

        return (
            <Box sx={{ textAlign: 'center', mt: 2 }}>
                {/*{current >= 1 ? <Button className={"transparantButton"} size="sm" onClick={() => {this.props.onChangePage(previousPage); this.toTop()}}><FontAwesomeIcon icon={faAngleLeft}/></Button> : null}*/}
                {/*<Button size="sm" onClick={() => {this.props.onChangePage(firstPage); this.toTop()}} className={`${current === 0 ? 'page-item active' : 'page-item'}`}>1</Button>*/}
                {/*{pageNumbers.length > 6 && current > 3 ? '...' : null}*/}

                {/*{this.state.popupItems.map( i => {*/}
                {pageNumbers.map((i) => (
                    // if (i > 1 && i < pageNumbers.length) {
                    //     if (pageNumbers.length > 5) {
                    //
                    <Button
                        key={i}
                        size="small"
                        variant="outlined"
                        sx={{ mx: 0.5 }}
                        onClick={() => {
                            this.popupMessagesPaginationChange(i - 1)
                            this.toTop()
                        }}
                    >
                        {i}
                    </Button>
                    // }
                    // } else {
                    //     return <Button size="sm" value={i} key={i} onClick={() => {this.props.onChangePage(i-1); this.toTop()}} className={`${current === (i-1) ? 'page-item active' : 'page-item'}`}>{i}</Button>
                    // }
                    // }
                ))}
                {/*{pageNumbers.length > 6 && current < pageNumbers.length-2 && current < pageNumbers.length-3 && current < pageNumbers.length-4 ? '...' : null}*/}
                {/*<Button size="sm" onClick={() => {this.props.onChangePage(lastPage); this.toTop()}} className={`${current === pageNumbers.length-1 ? 'page-item active' : 'page-item'}`}>{pageNumbers.length}</Button>*/}
                {/*{current <= this.props.pager.elements-2 ? <Button className={"transparantButton"} size="sm" onClick={() => {this.props.onChangePage(nextPage); this.toTop()}}><FontAwesomeIcon icon={faAngleRight}/></Button> : null}*/}
            </Box>
        )
    }

    popupMessagesPaginationChange(pageNumber) {
        this.setState({ currentPopUp: pageNumber }, this.fetchPopups)
    }
    getNewMessagesPopOver() {
        const { count, showPopOver, newMessages, loading } = this.state

        return (
            <Box>
                <IconButton
                    aria-label="messages"
                    onClick={() => {
                        this.fetchNewMessages()
                        this.setState({ showPopOver: !showPopOver })
                    }}
                    ref={this.target}
                    sx={{ position: 'relative' }}
                >
                    <FontAwesomeIcon icon={faBell} style={{ fontSize: 18 }} />
                    {count > 0 && (
                        <Badge
                            badgeContent={count}
                            color="error"
                            sx={{
                                position: 'absolute',
                                top: 4,
                                right: 4,
                            }}
                        />
                    )}
                </IconButton>

                <Popover
                    open={showPopOver}
                    anchorEl={this.target.current}
                    onClose={() => this.setState({ showPopOver: false })}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                >
                    <Box sx={{ p: 2, minWidth: 300 }}>
                        {loading ? (
                            <Box
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                }}
                            >
                                <CircularProgress size={24} />
                            </Box>
                        ) : !newMessages || newMessages.length === 0 ? (
                            <Typography
                                variant="body2"
                                align="center"
                                color="text.secondary"
                            >
                                {this.props.kedo.t('No unread messages')}
                            </Typography>
                        ) : (
                            this.getItems()
                        )}

                        <Box sx={{ mt: 1 }}>
                            <Link
                                to="/messages"
                                style={{ textDecoration: 'none' }}
                            >
                                <StyledButton
                                    fullWidth
                                    onClick={() => {
                                        this.setState({ showPopOver: false })
                                        this.toTop()
                                    }}
                                    startIcon={
                                        <FontAwesomeIcon icon={faInbox} />
                                    }
                                >
                                    {this.props.kedo.t('Go to')}{' '}
                                    {this.props.kedo.t('Inbox').toLowerCase()}
                                </StyledButton>
                            </Link>
                        </Box>
                    </Box>
                </Popover>
            </Box>
        )
    }

    componentWillUnmount() {
        this._isMounted = false
        clearInterval(this.state.popInterval)
        clearInterval(this.state.msgInterval)
    }

    componentDidMount() {
        this._isMounted = true
        setTimeout(() => {
            this.fetchCount()
            this.fetchNewMessages(true)
            this.fetchPopups(true)
        }, 5000)

        let msgInterv = setInterval(this.fetchCount, 100000)
        let popInterv = setInterval(this.fetchPopups, 300000)
        this.setState({
            popInterval: popInterv,
            msgInterval: msgInterv,
        })
    }

    render() {
        return (
            <>
                {this.state.popupItems && this.state.popupItems.length > 0
                    ? this.renderPopupItems()
                    : null}
                {this.getNewMessagesPopOver()}
            </>
        )
    }
}

export default MessagesPopOver
